import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LandingContext = createContext(null);

export function LandingProvider({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [mode, setMode] = useState("fulfillment");
  const [active, setActive] = useState(0);
  const [navSolid, setNavSolid] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(-1);
  const [howPlaying, setHowPlaying] = useState(false);
  const [activeSupply, setActiveSupply] = useState(null);

  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const toggleMenu = useCallback(() => setMenuOpen((v) => !v), []);

  const goTo = useCallback(
    (id, nextMode, page) => (e) => {
      if (e) e.preventDefault();
      const targetPath =
        page === "about" ? "/about" : page === "contact" ? "/contact" : page === "home" || !page ? "/" : page;

      const switchingPage = page && location.pathname !== targetPath && !(page === "home" && location.pathname === "/");

      if (nextMode) setMode(nextMode);
      setMenuOpen(false);
      if (id === "cta" || id === "how") setHowPlaying(false);

      const scroll = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: switchingPage ? "auto" : "smooth" });
          });
        });
      };

      if (switchingPage || (page === "home" && location.pathname !== "/")) {
        if (targetPath === "/") {
          navigate({ pathname: "/", hash: id || undefined });
        } else {
          navigate(targetPath);
        }
        setTimeout(scroll, 80);
      } else if (id) {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        else scroll();
      }
    },
    [location.pathname, navigate]
  );

  const value = useMemo(
    () => ({
      mode,
      setMode,
      active,
      setActive,
      navSolid,
      setNavSolid,
      menuOpen,
      setMenuOpen,
      closeMenu,
      toggleMenu,
      faqOpen,
      setFaqOpen,
      howPlaying,
      setHowPlaying,
      activeSupply,
      setActiveSupply,
      goTo,
      fulfillMode: mode === "fulfillment",
      productsMode: mode === "products",
    }),
    [
      mode,
      active,
      navSolid,
      menuOpen,
      faqOpen,
      howPlaying,
      activeSupply,
      closeMenu,
      toggleMenu,
      goTo,
    ]
  );

  return <LandingContext.Provider value={value}>{children}</LandingContext.Provider>;
}

export function useLanding() {
  const ctx = useContext(LandingContext);
  if (!ctx) throw new Error("useLanding must be used within LandingProvider");
  return ctx;
}
